import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';

export default class Popup extends AContainer {
  constructor(scene) {
    super(scene);

    this.createShader();
    this.createPopup();
    this.tweenInPopup();
  }

  createShader() {
    let rect = new Phaser.Geom.Rectangle(0, 0, this.scene.mid.x * 2, this.scene.mid.y * 2);
    this.shader = this.scene.add.graphics({ fillStyle: { color: 0x000000 } });
    this.shader.fillRectShape(rect);
    this.shader.setDepth(90);

    this.shader.alpha = 0;
  }

  createPopup() {
    this.bg = this.scene.addImage(0, 0, "Menu_Popup", ABCyaPhaser.Images.DEFAULT_ATLAS, this);
    this.home = this.scene.addButton(-150, 50, "Btn_Home_Menu", {}, () => { this.tweenOutPopup("home"); }, this);
    this.resume = this.scene.addButton(0, 50, "Btn_Resume", {}, () => { this.tweenOutPopup("resume"); }, this);
    this.mute = this.scene.addButton(150, 50, "Btn_Unmute", {}, () => { this.muteGame(); }, this);
    this.unmute = this.scene.addButton(150, 50, "Btn_Mute", {}, () => { this.unmuteGame(); }, this);

    this.header = ABCyaPhaser.Text.addText(0, -117, 70, 0xf9f5e1, FontKeys._fontBold, ABCyaPhaser.Localization.instance.getLocalizedString("popup_header"), this, true);

    this.buttons = [this.home, this.resume, this.mute, this.unmute];

    if (gameData.gameMuted) this.mute.visible = false;
    else this.unmute.visible = false;
    this.toggleButtons(false);

    this.setPosition(this.scene.mid.x, -100);
    this.setDepth(100);

    this.scene.addToParent(this, this.scene);
  }

  toggleButtons(TorF) {
    this.buttons.forEach((btn) => { btn.setEnabled(TorF) });

    if (!this.mute.visible) this.mute.setEnabled(false);
    if (!this.unmute.visible) this.unmute.setEnabled(false);
  }

  muteGame() {
    this.scene.playSound("click");

    gameData.gameMuted = true;

    this.scene.sound.setVolume(0);

    this.mute.visible = false;
    this.unmute.visible = true;

    this.mute.setEnabled(false);
    this.unmute.setEnabled(true);
  }

  unmuteGame() {
    gameData.gameMuted = false;

    this.scene.sound.setVolume(1);

    this.mute.visible = true;
    this.unmute.visible = false;

    this.mute.setEnabled(true);
    this.unmute.setEnabled(false);
  }

  tweenInPopup() {
    this.scene.addTween(this.shader, 500, { alpha: .66 }, Phaser.Math.Easing.None);

    this.scene.addTween(this, 1000, { y: this.scene.mid.y }, Phaser.Math.Easing.Back.Out,
      () => {
        this.toggleButtons(true);
      });
  }

  tweenOutPopup(type) {
    this.scene.playSound("click");

    this.toggleButtons(false);

    this.scene.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.None);

    this.scene.addTween(this, 1000, { y: -200 }, Phaser.Math.Easing.Back.In,
      () => {
        if (type === "home") {
          this.cleanUp();
          this.scene.cleanUp("Intro");
        }
        else if (type === "resume") {
          this.cleanUp();
          this.scene.resumeGame();
        }
      });
  }

  cleanUp() {
    //console.log("cleaning UP");
    this.shader.destroy();
    this.bg.destroy();

    this.buttons.forEach((btn) => {
      btn.setEnabled(false);
      btn.destroy();
    });

    this.buttons = [];
  }
}